import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import { persistConfig } from "./persist/persistConfig";
import { persistSchool } from "./persist/persistSchool";
import { persistAssessment } from "./persist/persistAssessment";
import i18nReducer from "./slices/i18nSlice";
import themeReducer from "./slices/themeSlice";
import authReducer from "./slices/authSlice";
import { configurationSlice } from "./slices/configurationSlice";
import { schoolSlice } from "./slices/schoolSlice";
import { challengeSlice } from "./slices/challengeSlice";

import { RESET_STORE } from "./actions/resetAction";

import {
  syncAcrossTabsMiddleware,
  setupBroadcastListener,
} from "./syncAcrossTabsMiddleware";

// 🔐 schoolSlice persistant partiellement
const persistedSchoolReducer = persistReducer(
  persistSchool,
  schoolSlice.reducer,
);

const persistedAssessmentReducer = persistReducer(
  persistAssessment,
  challengeSlice.reducer,
);

const appReducer = combineReducers({
  i18n: i18nReducer,
  theme: themeReducer,
  auth: authReducer,
  setInitConf: configurationSlice.reducer,
  schoolState: persistedSchoolReducer,
  challengeState: persistedAssessmentReducer,
});

// 🔥 ROOT REDUCER GLOBAL RESET
const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined; // reset total
  }

  // reset partial by keeping the theme and languages
  // if (action.type === RESET_STORE) {
  //   state = {
  //     i18n: state?.i18n,
  //     theme: state?.theme,
  //   };
  // }

  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const allowedPrefixes = [
  "setUp/initConnectedUser",
  "setUp/setUserInformations",
  "setUpSchool/onCurrentStream",
  "setUpChallenge/setCurrentAssessment",
  "setUpChallenge/setLessonAssessment",
];

const syncMiddleware = syncAcrossTabsMiddleware(allowedPrefixes);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(syncMiddleware),
});

export const persistor = persistStore(store);

// Active la synchro inter-onglets
setupBroadcastListener(store);
